import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import fresh_banner from '../../assets/fresh-banner-second.jpg';
import { getDeviceType } from '../../utils/common';
import { pageAction } from '../../redux_files/actions/page_actions';

const FreshnessAndHygiene = () => {
	const dispatch = useDispatch();
	const [deviceType, setDeviceType] = useState(getDeviceType());
	useEffect(() => {
		window.addEventListener('resize', setDeviceType(getDeviceType()));
		return () => window.removeEventListener('resize', setDeviceType(getDeviceType()));
	}, []);

	useEffect(() => {
		document.title = 'Blogs | How We Ensure Freshness & Hygiene in Every Meal';
		dispatch(pageAction('Fresh & Hygienic'));
	});
	return (
		<>
			<img src={fresh_banner} alt='Banner' width='100%' height={deviceType !== "mobile" ? "420" : "150"} />
			<div className='container'>


				<article>
					{deviceType === "mobile" ? <h3>🧼 How We Ensure Freshness & Hygiene in Every Meal</h3> : <h2>🧼 How We Ensure Freshness & Hygiene in Every Meal</h2>}
					<p>When it comes to food, <strong>taste matters</strong>, but <strong>safety and cleanliness</strong> matter even more.</p>
					<p>At <strong>Shivay Durga Foods</strong>, we believe every meal should not only taste delicious but also be <em>fresh, hygienic, and prepared with care</em>—just like at home.</p>
					<p>Here’s how we ensure <strong>unmatched quality and hygiene</strong> in everything we serve:</p>

					<b>🌿 1. Fresh Ingredients, Sourced Daily</b>
					<p>
						• Vegetables are sourced <strong>daily</strong> from trusted local vendors<br />
						• We use <strong>cold-pressed oils</strong> and <strong>unrefined flours</strong><br />
						• Only <strong>certified and branded spices & grains</strong> are used
					</p>

					<b>🧼 2. Strict Kitchen Hygiene Protocols</b>
					<p>
						• Staff wear <strong>gloves, caps, and aprons</strong> at all times<br />
						• Kitchen surfaces and utensils are <strong>cleaned 3x daily</strong><br />
						• <strong>Separate chopping boards</strong> for raw and cooked food
					</p>

					<b>📦 3. Clean Packaging, Every Time</b>
					<p>
						• <strong>Leak-proof, food-grade containers</strong> used for packing<br />
						• <strong>Contactless packing</strong> by gloved staff<br />
						• Security seals used to prevent tampering
					</p>

					<b>🧊 4. Temperature-Controlled Storage</b>
					<p>
						• Proper refrigeration for perishables<br />
						• No reuse of leftovers—<strong>zero compromise</strong><br />
						• <strong>Time-stamped inventory</strong> to track freshness
					</p>

					<b>🧑‍🍳 5. Trained & Certified Kitchen Staff</b>
					<p>
						• <strong>Monthly hygiene training</strong> for all staff<br />
						• Health screening before food handling<br />
						• Regular <strong>FSSAI-compliance checks</strong>
					</p>

					<b>🔁 6. Zero Waste, Zero Reuse</b>
					<p>
						• No food carried over to the next day<br />
						• Leftover food is <strong>donated or discarded</strong> responsibly<br />
						• <strong>Small-batch cooking</strong> ensures daily freshness
					</p>

					<b>👀 7. Customer Feedback Loop</b>
					<p>
						• We welcome reviews and suggestions<br />
						• Random quality checks after deliveries<br />
						• <strong>Instant replacement/refund</strong> in case of any issue
					</p>

					<b>✅ Final Word: Clean Food is Real Food</b>
					<p>In every roti, every spoon of dal, every bite of biryani—you’ll taste the difference.</p>
					<p>Because <strong>freshness isn’t an option</strong>, and <strong>hygiene isn’t negotiable</strong>.
						It`s the <strong>Shivay Durga Foods standard</strong>.</p>
				</article>
			</div>
		</>
	);
};
export default FreshnessAndHygiene;
